export const MAIN_RULES = {
    name: {
        value: 120,
        message: "Максимальная длина 120 символов",
    },
    phone: { value: /^7\d{10}$/, message: "Введите телефон в формате 7XXXXXXXXXX" },
    address_index: {
        value: /^\d{6}$/,
        message: "Индекс должен содержать 6 цифры",
    },
    passport_seria: { value: /^\d{4}$/, message: "Серия паспорта должна содержать 4 цифры" },
    passport_number: { value: /^\d{6}$/, message: "Номер паспорта должна содержать 6 цифры" },
    passport_place_code: { value: /^\d{3}-\d{3}$/, message: "Код подразделения в формате XXX-XXX" },
    message: {
        value: 250,
        message: "Максимальная длина 250 символов",
    },
};
